import { useParams, Navigate } from 'react-router-dom';

const ShortLinkRedirect = () => {
  const { shortId } = useParams();
  return <Navigate to={`/mobile/${shortId}`} replace />;
};

export default ShortLinkRedirect;
